export const getDateWithTime = (date: Date | null, HHmm?: string): Date | null => {
    if (!date || !HHmm) return null;

    const formattedDate = new Date(date);
    const [hours, minutes] = HHmm.split(':');

    formattedDate.setHours(+hours, +minutes, 0); // Set hours, minutes and seconds
    return formattedDate;
};

export const getUtcDateTimeString = (date: Date | null, HHmm?: string): string | null => {
    const dateStr = getDateWithTime(date, HHmm)?.toISOString() ?? null;
    return dateStr;
};
